import { object, string } from 'yup';
import { validateEmail } from './global';
export const EmailValidation = (t) =>
  object().shape({
    email: string()
      .required(t('emailIsRequired'))
      .matches(validateEmail, t('emailError')),
  });

export const CommentValidation = (t) =>
  object().shape({
    comment: string().required(t('commentRequired')),
  });
